/**
 * Local elegido por el admin en pantalla. Se manda en cada pedido (header X-Branch-Id);
 * para un cajero el servidor lo ignora y usa siempre su local asignado.
 */
const KEY = 'selectedBranchId';

export function getSelectedBranchId(): string | null {
    try {
        return localStorage.getItem(KEY);
    } catch {
        return null;
    }
}

export function setSelectedBranchId(id: string | null): void {
    try {
        if (id) localStorage.setItem(KEY, id);
        else localStorage.removeItem(KEY);
    } catch {
        // Sin almacenamiento: el servidor usa el local asignado al usuario
    }
}
